// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3kVxV","errorLogs":"EditorFooter_errorLogs__1JDXt"};